// removed by extract-text-webpack-plugin
module.exports = {"hidden":"kDy8y","visuallyhidden":"_3Pkki","hide-text":"_1Nn6f","center":"_2dtu1","noprint":"_1jw-e","root":"_2ZFt-"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/cn-skin-core/styles/svg/UserLoggedInButton.scss
 ** module id = 445
 ** module chunks = 0
 **/